import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Container from '../Container/Index';
import SSgroup from './Logo/SSgroup';
import ImageTag from '../ImageTag/Index';
import Camasa from '../../images/camasa-logo.webp';
import { Link } from 'react-router-dom';

const Index = ({ Data }) => {
  const [isScroll, setIsScroll] = useState(false);

  useEffect(() => {
    const handelScroll = () => {
      if (window.scrollY > 350) {
        setIsScroll(true);
      } else {
        setIsScroll(false);
      }
    };
    window.addEventListener('scroll', handelScroll);
    return () => {
      window.removeEventListener('scroll', handelScroll);
    };
  }, []);

  return (
    <Container _parentClass={`position-absolute z-10 py-sm-4 py-sm-2 py-3 headerSection ${isScroll ? 'scrolled' : ''}`}>
      <div className="flex flex-wrap w-full align-items-center">
        <div className="w-1/2">
          <Link to='/'>
            <motion.div
              className="w-[120px] 2xl:w-[180px] md:w-[150px]"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
            >
              <ImageTag ImagePath={Camasa} ImageClass={'w-full'} />
            </motion.div>
          </Link>
        </div>

        <div className="w-1/2">
          <div className="w-full flex justify-end items-center gap-2 md:gap-0">
            <motion.div
              className="!hidden 2xl:w-[320px] md:w-[220px] w-full justify-end lg:justify-start items-center 2xl:text-[26px] md:text-[19px] text-white gap-3  sm:flex text-end"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.3 }}
            >
              <a
                className='!hidden sm:block'
                href="tel:9861600300"
                onClick={(e) => {
                  e.preventDefault();

                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: "sscamasa_call_desktop",
                    phone_number: "9861600300",
                    click_location: "header"
                  });

                  // ✅ delay ke baad call open karo
                  setTimeout(() => {
                    window.location.href = "tel:9864800888";
                  }, 200);
                }}
              ><span className='font-extralight'>CALL</span> <strong>9861 600 300</strong>
              </a>
              <a
                className='sm:hidden flex items-end justify-end w-full'
                href="tel:9861600300"
                onClick={(e) => {
                  e.preventDefault();

                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: "sscamasa_call_mobile",
                    phone_number: "9861600300",
                    click_location: "header"
                  });

                  // ✅ delay ke baad call open karo
                  setTimeout(() => {
                    window.location.href = "tel:9861600300";
                  }, 200);
                }}
              >
                <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv !w-8 !h-8  opacity-40" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CallIcon"><path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99"></path></svg>
              </a>
            </motion.div>

            <motion.div
              className="2xl:w-[100px] w-[80px]"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.5 }}             >
              <SSgroup />
            </motion.div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Index;